export default __webpack_public_path__ + "static/media/b33.6c541c94.png";